import { useCallback, useState } from 'react';

import { useConfirmDialog } from '@/hooks/useConfirmDialog';

export function usePerItemSaveUiState() {
  const [savingById, setSavingById] = useState<Record<string, boolean>>({});
  const [saveErrorById, setSaveErrorById] = useState<Record<string, string | null>>({});

  const setSaving = useCallback((id: string, v: boolean) => {
    setSavingById((p) => ({ ...p, [id]: v }));
  }, []);

  const setSaveError = useCallback((id: string, msg: string | null) => {
    setSaveErrorById((p) => ({ ...p, [id]: msg }));
  }, []);

  const clearItem = useCallback((id: string) => {
    setSavingById((p) => {
      const c = { ...p };
      delete c[id];
      return c;
    });
    setSaveErrorById((p) => {
      const c = { ...p };
      delete c[id];
      return c;
    });
  }, []);

  const clearAll = useCallback(() => {
    setSavingById({});
    setSaveErrorById({});
  }, []);

  return {
    savingById,
    saveErrorById,
    setSaving,
    setSaveError,
    clearItem,
    clearAll,
  };
}

export function useConfirmingDelete() {
  const confirm = useConfirmDialog();

  const confirmDelete = (title?: string, entityName = 'item') => {
    const label = title?.trim() ? `"${title.trim()}"` : `this ${entityName}`;
    return confirm({
      title: `Delete ${label}?`,
      description: 'This cannot be undone.',
      confirmLabel: 'Delete',
      variant: 'destructive',
    });
  };

  return { confirmDelete };
}
